import { useCallback, useEffect, useMemo, useState } from 'react'

import { CompanyHistory } from 'commons/types/DTO/bank/companyDetails/companyHistory'
import { HistoryEntity } from 'commons/types/DTO/bank/historyAudit'
import { useTableState } from 'ui/components/Table'

import { handlerServerError } from '@orbit/errors'

import { useFilterCompanyHistoryWebPage } from './useFilterCompanyHistoryWebPage'

export const useCompanyHistory = (
  companyId: number,
  initialCompanyHistory: HistoryEntity[],
  initialCompanyHistoryTotalCount: number
) => {
  const [loading, setLoading] = useState(false)

  const defaultFilter = useMemo(
    () => ({
      relationshipId: companyId,
      page: 1,
      size: 10
    }),
    []
  )

  const [webPageData, setWebPageData] = useState<CompanyHistory>({
    history: initialCompanyHistory,
    historyTotalCount: initialCompanyHistoryTotalCount
  })

  useEffect(() => {
    setWebPageData({
      history: initialCompanyHistory,
      historyTotalCount: initialCompanyHistoryTotalCount
    })
  }, [initialCompanyHistory, initialCompanyHistoryTotalCount])

  const { routine: filterCompanyHistoryWebPage } = useFilterCompanyHistoryWebPage({
    onSuccess: async (_, result) => {
      await setWebPageData(result)
    },
    onError: (error) => handlerServerError(error)
  })

  const [tableFilter, setTableFilter] = useState<{
    relationshipId: number
    page: number
    size: number
  }>(defaultFilter)

  const tableState = useTableState({ filter: {} })

  const changePagination = useCallback(
    async (page: number, size: number) => {
      setLoading(true)

      tableState.onPageChange(page, size)

      const filter = {
        ...tableFilter,
        page,
        size
      }

      setTableFilter(filter)

      await filterCompanyHistoryWebPage(filter)

      setLoading(false)
    },
    [filterCompanyHistoryWebPage, tableFilter, tableState]
  )

  return {
    loading,
    webPageData,
    tableState,
    changePagination
  }
}
